<template>
  <section class="dto">
    <div class="dto-basic">
      <div>
        <com-carousel
          v-if="contentData && contentData.imgList.length >= 2"
          :imgs="contentData.imgList"
          height="300px"
        />
        <img
          v-if="contentData && contentData.imgList.length == 1"
          :src="obj.imgList[0].img"
          alt=""
        >
        <comDtoBasic2
          :list="basicBtnList"
          :obj="contentData"
          :is-active="is_collection"
          @evaluate="handleEvaluate"
          @edit="handleEdit"
        />
      </div>
    </div>
    <div class="dto-content">
      <div>
        <com-tabs
          :list="tabsList"
          class="dto-tabs"
          :default-tab="activeTab"
          @change="changeTab"
        >
          <template v-slot:text="{ obj }">
            <div
              :class="{ activeTab: activeTab == obj.key }"
              class="dto-tabs-item"
            >
              {{ obj.name }}
            </div>
          </template>
        </com-tabs>
      </div>
      <div>
        <com-dto-content1 :title="contentTitle" :obj="contentData1" />
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api/app'
import mock from '@/utils/mock'
import comCarousel from '@/components/comCarousel'
import comDtoBasic2 from './comDtoBasic2.vue'
import comDtoContent1 from './comDtoContent1.vue'
import comTabs from '@/components/comTabs'
export default {
  components: {
    comCarousel,
    comDtoBasic2,
    comDtoContent1,
    comTabs
  },
  data() {
    return {
      contentData: null,
      contentData1: null,
      content: null,
      is_collection: false,
      loading: false,
      requestParams4: {
        collection_id: null,
        collection_type: 2
      },
      contentTitle: '',
      activeTab: 0,
      tabsList: [
        {
          id: 111,
          key: 0,
          name: '详情介绍',
          type: 'text'
        },
        {
          id: 222,
          key: 1,
          name: '创客空间',
          type: 'text'
        },
        {
          id: 333,
          key: 2,
          name: '未来空间',
          type: 'text'
        }
      ],
      equipInit: mock.school.school.init,
      equipViewInfo: mock.school.school.viewInfo
    }
  },
  computed: {
    basicBtnList() {
      const arr = this.equipViewInfo.obj.btns1
      arr.map((item, index) => {
        if (index != 2) {
          item.id = this.$route.query.id
        }
      })
      return arr
    }
  },
  mounted() {
    this.loading = true
    this.init()
  },
  methods: {
    async init() {
      if (this.$route.query.id) {
        const id = this.$route.query.id
        this.contentData = await this.equipInit.dto({
          school_id: id
        })
        this.contentTitle = this.tabsList[0].name
        this.contentData1 = this.contentData
        this.loading = false
        this.is_collection = this.contentData.is_collection == 1
        this.equipViewInfo.obj.btns.map((item) => {
          if (item.model == 'evaluate') {
            item.status = this.is_collection ? 2 : 0
          }
        })
      }
    },
    handleEvaluate(v) {
      this.requestParams4.collection_id = this.$route.query.id
      if (v) {
        this.$confirm('确认取消收藏吗?', '提示', {})
          .then(() => {
            api.mine.delete.collect(this.requestParams4).then((res) => {
              this.$message.success('取消收藏成功')
              this.init()
            })
          })
          .catch(() => {})
      } else {
        this.$confirm('确认收藏吗?', '提示', {})
          .then(() => {
            api.mine.create.collect(this.requestParams4).then((res) => {
              this.$message.success('收藏成功')
              this.init()
            })
          })
          .catch(() => {})
      }
    },
    handleEdit() {
      this.$router.push({
        path: '/school/roam',
        query: {
          src: this.contentData.design_pano_url_ai
        }
      })
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    changeTab(v) {
      this.contentTitle = this.tabsList[v].name
      if (v == 0) {
        this.contentData1 = this.contentData
      } else if (v == 1) {
        this.contentData1 = this.contentData.school_room[0]
      } else {
        this.contentData1 = this.contentData.school_room[1]
      }
    },
    handleStatus10(v) {
      this.equipViewInfo.obj.btns.map((item, index) => {
        if (v == index) {
          if (item.status == 1) {
            item.status = 0
          }
        }
      })
    },
    handleStatus11(v) {
      this.equipViewInfo.obj.btns.map((item, index) => {
        if (v == index) {
          if (item.status == 0) {
            item.status = 1
          }
        }
      })
    },
    handleControl(v) {
      if (v == 'evaluate') {
        if (!this.is_collection) {
          this.$confirm('确认收藏吗?', '提示', {})
            .then(() => {
              api.mine.create.collect(this.requestParams4).then((res) => {
                this.$message.success('收藏成功')
                this.init(this.$route.query.id)
              })
            })
            .catch(() => {})
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dto {
  @include fun-layout(1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &-tabs {
    margin: 0 35px;
    &-item {
      text-align: center;
      @include fun-design(7);
      line-height: 40px;
      width: 60px;
      cursor: pointer;
    }
    .activeTab {
      @include fun-active();
    }
  }
  &-basic {
    height: 49.57%;
    width: 100%;
    > div {
      height: 100%;
      margin-left: 90px;
      background-color: #fff;
      box-shadow: 0px 0px 4px 3px rgba(85, 85, 85, 0.01);
      border-radius: 6px;
      display: flex;
      > section {
        &:nth-child(1) {
          width: 850px;
        }
        &:nth-child(2) {
          flex: 1;
        }
      }
    }
  }
  &-content {
    height: 48.37%;
    width: 100%;
    display: flex;
    > div {
      &:nth-child(1) {
        width: 90px;
      }
      &:nth-child(2) {
        flex: 1;
        background-color: #fff;
        height: 100%;
        > section {
          height: 100%;
        }
      }
    }
  }
}
</style>
